export const isStringNumberOrBoolean = (value: unknown): value is string | number | boolean => {
  const types = ['string', 'number', 'boolean'];

  return types.includes(typeof value);
};
